import React from "react"
import PropTypes from "prop-types"

/**
 * Four-square grid used by the AI Assistant's input row to reopen the quick-action menu
 * (Book a Trip, Show Today's Bookings/Reservations, Process a Refund, Manage Bookings).
 *
 * Uses currentColor so it inherits the button's text color.
 */
export const GridMenu = ({ height = 20, width = 20, stroke = "currentColor" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <rect x="3" y="3" width="7" height="7" rx="1" stroke={stroke} strokeWidth={2} />
    <rect x="14" y="3" width="7" height="7" rx="1" stroke={stroke} strokeWidth={2} />
    <rect x="3" y="14" width="7" height="7" rx="1" stroke={stroke} strokeWidth={2} />
    <rect x="14" y="14" width="7" height="7" rx="1" stroke={stroke} strokeWidth={2} />
  </svg>
)

GridMenu.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  stroke: PropTypes.string
}

export default GridMenu
